import { type StoreApi } from 'zustand'

import {
  INITIAL_DASHBOARD_STORE_VALUES,
  type DashboardStoreValuesType,
} from '@/features/ui/pages/dashboard/stores/dashboard/dashboard.store'

export function setSelectedGroupIdAction(
  set: StoreApi<DashboardStoreValuesType>['setState'],
  groupId: string | null,
) {
  set({ selectedGroupId: groupId })
}

export function resetDashboardStoreAction(set: StoreApi<DashboardStoreValuesType>['setState']) {
  set(INITIAL_DASHBOARD_STORE_VALUES)
}
